import { jsx as _jsx } from "react/jsx-runtime";
import { usePortal } from '../../../../hooks/usePortal';
export const PortalContainer = ({ children }) => {
    const Portal = usePortal();
    return _jsx(Portal, { children: children }, void 0);
};
//# sourceMappingURL=PortalContainer.js.map